import { render } from "./ArticleDetailView.vue?vue&type=template&id=7460f9ac"
import script from "./ArticleDetailView.vue?vue&type=script&lang=ts"
export * from "./ArticleDetailView.vue?vue&type=script&lang=ts"
script.render = render

export default script